/*
 * 首页模块接口
 */

import { post, get } from 'api/http'

export default {
    // 获取首页信息
    getIndexInfo(data) {
        return get('/wx/user/personalCenter', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/home.js